module.exports = __webpack_public_path__ + "img/vac-pan-photo.6415d190.png";